module.exports = __webpack_public_path__ + "static/vmware_3.37714985.jpg";